<template>
  <div>
    <div class="product_mobile banner-bg">
      <div class="banner-container ">
        <div class="banner-title banner-center animate__zoomInDown">SmallStep Funvalley</div>

        <div class="banner-content banner-center animate__zoomIn">
          {{ $t('bannerSubTitle') }}
        </div>
        <div class="banner-content banner-center animate__zoomIn">
          {{ $t('bannerSubText1') }}&nbsp;&nbsp;/&nbsp;&nbsp;{{ $t('bannerSubText2') }}&nbsp;&nbsp;/&nbsp;&nbsp;{{
            $t('bannerSubText3') }}
        </div>
      </div>
    </div>

    <div class="companyIntroduction pathContainer">
      <div class="small-block-introduction bg-block"></div>
      <div class="big-block-introduction bg-block"></div>
      <div id="AboutUs" class="head-label">
        {{ $t('title1') }}
      </div>
      <div class="company-introduction content-card text1" style="padding-top: 0px;">
        {{ $t('desc1') }}
      </div>
      <div class="company-introduction content-card text1">
        {{ $t('desc2') }}
      </div>
    </div>

    <div class="advantageContainer" style="position: relative;margin-bottom:3em">
      <div class="big-block-advantage bg-block"></div>
      <div id="我们的优势" class="head-label">
      </div>
      <div class="advantage-container">
        <div class="advantage-parent">
          <el-row :gutter="10">
            <el-col v-for="(item, index) in advantages" :key="index" :xs="12" :sm="12" :md="6">
              <div class="advantage-img-parent">
                <img :src="item.img" class="advantage-img" />
              </div>
              <div class="advantage-title">{{ $t(item.title) }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>


    <div>
      <div id="Products" class="head-label">
        {{ $t('title2') }}
      </div>

      <img class="product-test" src="../assets/legu/product1.jpg">

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fixed: false,
      advantages: [
        { title: 'phrase1', img: require('../assets/smallStep/官网_slices-1/ad1.png') },
        { title: 'phrase2', img: require('../assets/smallStep/官网_slices-1/ad2.png') },
        { title: 'phrase3', img: require('../assets/smallStep/官网_slices-1/ad3.png') },
        { title: 'phrase4', img: require('../assets/smallStep/官网_slices-1/ad4.png') }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="css" scoped>
@import '../assets/css/main.css';

/* bg-block */
.pathContainer {
  overflow: hidden;
}

.companyIntroduction {
  position: relative;
  overflow: hidden;
}

.bg-block {
  position: absolute;
  background-size: cover;
}


.small-block-introduction {
  background-image: url('../assets/smallStep/官网_slices/矩形8拷贝4.png');
  width: 64px;
  height: 64px;
  top: 20px;
  /* right: 10%; */
  left: 84%;
}

.big-block-introduction {
  background-image: url('../assets/smallStep/官网_slices/矩形8.png');
  /* width: 173px; */
  width: 328.5px;
  height: 328.5px;
  /* width: 657px;
    height: 657px; */
  left: 87%;
  /* right: -10%; */
  top: 73px;
}

.big-block-advantage {
  background-image: url('../assets/smallStep/官网_slices/矩形8拷贝.png');
  width: 328.5px;
  height: 328.5px;
  top: 40%;
  left: -8%;
}

.big-block-benefit {
  background-image: url('../assets/smallStep/官网_slices/矩形8拷贝3.png');
  width: 151px;
  height: 151px;
  top: 10%;
  left: -2%;
}

.small-block-benefit {
  background-image: url('../assets/smallStep/官网_slices/矩形8拷贝2.png');
  width: 80px;
  height: 80px;
  top: 5%;
  right: 10%;

}

.xs-block-benefit {
  background-image: url('../assets/smallStep/官网_slices/矩形8拷贝5.png');
  width: 226px;
  height: 226px;
  bottom: -35%;
  right: 0%;
}

/* bg-block */


.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid #959ba0 !important;
}

.product_mobile {
  align-items: center;
}

.product-test {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  display: inline-block;
  width: 920px;
  border-radius: 20px;
  margin-bottom: 100px;
}


.banner-bg {
  background-image: url('../assets/legu/banner.jpg');
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 663px;
  background-repeat: no-repeat;
  position: relative;
  color: #fff;
}

.banner-bg .banner-container {
  width: 80%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.banner-title {
  font-size: 5em;
  font-weight: 500;
  margin-bottom: 1em;
}

.banner-center {
  text-align: center;
}

.banner-content {
  font-size: 1.5rem;
  font-weight: 400;
  margin-top: 1em;
}

.head-label {
  font-size: 40px;
  text-align: center;
  padding-top: 67px;
  font-weight: bold;
  margin-bottom: 80px;
}

.content-card {
  width: 62% !important;
  padding-top: 30px;
  margin: 0 auto;
}

.text1 {
  font-size: 28px;
  line-height: 48px;
  font-family: PingFangSC-Regular, PingFang SC, "Gill Sans", sans-serif;
  font-weight: 400;
  color: #000;
}

.advantage-container {
  width: 62%;
  margin: 0 auto;
}

.advantage-img-parent {
  text-align: center;
}


.advantage-img {
  display: inline-block;
  margin: 0 auto;
  box-shadow: 0 0.75em 0.75em 0 rgb(0 0 0 / 20%);
  width: 11.65625em;
  height: 8.28125em;
  border-radius: 1.125em;
}

.advantage-title {
  margin-top: 3.4375em;
  text-align: center;
  font-size: 1.125em;
  font-weight: bold;
}

.footer {
  font-size: 0.1em;
  text-align: center;
  justify-content: space-between;
}

.footer span {
  width: 33%;
}
</style>
<style scoped>
@media screen and (max-device-width: 415px) {
  .banner-title {
    font-size: 30px;
  }

  .banner-content {
    font-size: 14px;
  }

  .head-label {
    margin-bottom: 30px;
  }

  .company-introduction {
    font-size: 1em;
    line-height: 1.5em;
    padding-top: 15px;
  }

  .content-card {
    width: 80% !important;
  }

  .advantage-container {
    width: 80%;
  }

  .advantage-title {
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
  }


  .product_mobile {
    align-items: center;
    height: auto;
  }

  .product-test {
    width: 90%;
  }

  .banner-bg {
    height: 250px;
    width: 100%;
    /* margin: 0 auto; */
    background-size: cover;
    background-position: 50%;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px auto;
    width: 90%;
    color: #222;
    font-size: 0.88em;
    opacity: 0.6;
  }

  .footer span {
    /* width: 30%; */
    text-align: center;
  }

  .footer span a {
    display: inline-block;
  }
}
</style>
